<script lang="ts">
  import axios from 'axios';
	import { createEventDispatcher } from 'svelte';
  
  const dispatch = createEventDispatcher();

  export let symbol: string;
  
  let leverage = 10;

  function cancel() {
    console.log('dispatching close')
    dispatch('close')
  }

  async function submit(side: string) {
    if(symbol == null || typeof symbol === undefined) {
      return;
    }

    try {
      console.log('submitting');
      const url = "https://rkiengxqz4asox73cryq54mpx40ugtyg.lambda-url.eu-west-2.on.aws/";
      const data =  `${side},${symbol},${leverage}`;
      console.log('data', data);
      const result = await axios({
        method: 'post',
        url, 
        data,
        headers: {
          'Content-Type': 'text/plain'
        }
      });
      console.log('result', result);
      dispatch('close');
    } catch (error) {
      console.log('error', error)
      alert("failure");
    }
  }
</script>

<div class="wide">
  <div class="wide">
    <label for="leverage">leverage</label>
    <select name="leverage" bind:value={leverage} class="wide">
      <option value={10}>10</option>
      <option value={20}>20</option>
    </select>
  </div>

  <div class="">
    <button on:click={() => submit('BUY')} class="wide green">Long</button>
    <button on:click={() => submit('SELL')} class="wide red">Short</button>
    <button on:click={cancel} class="wide black">Cancel</button>
  </div>
</div>

<style>
  button {
    font-size: x-large;
    height: 4rem;
    margin-top: 1rem;
  }

  select {
    height: 2rem;
  }

  .black {
    background-color: black;
    color: white;
  }

  .green{
    background-color: green;
  }

  .red {
    background-color: red;
  }

  .wide {
    width: 100%;
  }
</style>
